import { Component } from '@angular/core';
import { NavController, ToastController } from 'ionic-angular';
import { AngularFireAuth } from 'angularfire2/auth';

import { Data } from '../../providers/providers';
import { LocationListPage } from "../location-list/location-list";
import {PasswordResetPage} from "../password-reset/password-reset";

@Component({
  selector: 'page-signup',
  templateUrl: 'signup.html'
})

export class SignupPage {

  account: { email: string, password: string } = {
    email: 'test@example.com',
    password: 'test123'
  };

  private signupErrorString: string;

  constructor(public navCtrl: NavController,
    private firebaseAuth: AngularFireAuth,
    public data: Data,
    public toastCtrl: ToastController)
  {
    this.signupErrorString = "Unable to create account. Please check your account information and try again.";
  }

  doSignup() {
    this.firebaseAuth
      .auth
      .createUserWithEmailAndPassword(this.account.email, this.account.password)
      .then(value => {
        this.data.createUser(this.account.email);
        this.navCtrl.push(LocationListPage);
      })
      .catch(err => {
          let toast = this.toastCtrl.create({
            message: err.message,
            duration: 3000,
            position: 'top'
          });
          toast.present();
      });
  }

  resetPassword() {
    this.navCtrl.push(PasswordResetPage, {});
  }

}



// WEBPACK FOOTER //
// ./src/pages/signup/signup.ts